<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h2>ทำรายการยืม/คืน</h2>
      </div>
      <div class="card-body">
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-select
              v-model="query.loan"
              :items="loanType"
              item-text="label"
              item-value="val"
              label="เลือกการยืม"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
          >
            <v-select
              v-model="query.agentId"
              :items="agents"
              item-text="name"
              item-value="id"
              label="เลือกเอเจน"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              v-model="amount"
              align="center"
              label="กรอกจำนวนเงิน"
              outlined
              pattern="\d{5,8}"
              maxlength="8"
              min="5"
              required
              @keypress="validateNumber($event)"
            />
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-btn
              color="success"
              large
              @click="addLoan"
            >
              บันทึก
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="card mt-5">
      <div class="card-header">
        <h2>รายการ</h2>
      </div>
      <div class="card-body">
        <v-row>
          <v-col
            cols="12"
            sm="5"
          >
            <v-select
              v-model="agentId"
              :items="agents"
              item-text="name"
              item-value="id"
              label="เลือกเอเจน"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            sm="5"
          >
            <v-menu
              ref="showDateDialog"
              v-model="showDateDialog"
              :close-on-content-click="false"
              :return-value.sync="dateSelect"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="dateSelectDisplay"
                  label="วันที่"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker
                v-model="dateSelect"
                no-title
                @change="
                  $refs.showDateDialog.save(dateSelectDisplay);
                  showDateDialog = false;
                "
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            sm="2"
          >
            <v-btn
              color="primary"
              large
              @click="fetchData(query.slug)"
            >
              <v-icon left>
                mdi-check
              </v-icon>
              ค้นหา
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :footer-props="footer"
          :headers="headers"
          :items.sync="items"
          :loading="loading"
          :multi-sort="false"
          :options.sync="options"
          :server-items-length="totalItems"
          class="elevation-0"
          item-key="id"
        >
          <!-- item -->
          <template #item.created_at="{ item }">
            <span
              v-if="item.created_at"
              class="d-block"
            >{{
              $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
          <template #item.type="{ item }">
            <v-chip
              v-if="item.type == 'debit'"
              class="ma-2"
              color="green"
              outlined
            >
              ให้ยืม <v-icon>mdi-arrow-right-thick</v-icon>
            </v-chip>

            <v-chip
              v-else-if="item.type == 'credit'"
              class="ma-2"
              color="red"
              outlined
            >
              ดึงคืน <v-icon>mdi-arrow-left-thick</v-icon>
            </v-chip>
          </template>

          <template #item.status="{ item }">
            <v-chip
              v-if="item.status == 'request'"
              class="ma-2"
              color="red"
              outlined
            >
              ปฏิเสธรายการ
            </v-chip>

            <v-chip
              v-else-if="item.status == 'approved'"
              class="ma-2"
              color="blue"
              outlined
            >
              อนุมัติ
            </v-chip>
            <v-chip
              v-else
              class="ma-2"
              color="gray"
              outlined
            >
              ยกเลิกรายการ
            </v-chip>
          </template>
          <template #item.user="{ item }">
            {{ item.result_limit.user.name }}
          </template>

          <template #item.amount="{ item }">
            <span>{{ Intl.NumberFormat("th-TH").format(item.amount) }}</span>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'AdminLoan',
  props: {
    agents: { default: '', Type: Array },
  },
  data() {
    return {
      footer: {
        itemsPerPageOptions: [50, 100],
      },
      loading: true,
      search: false,
      sortable: false,
      headers: [
        {
          text: 'วันที่',
          value: 'created_at',
          align: 'center',
          sortable: false,
        },
        {
          text: 'ผู้อนุมัติ',
          value: 'approved_by_info.name',
          align: 'left',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'ประเภท',
          value: 'type',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'เอเจน',
          value: 'user.name',
          align: 'left',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'สถานะ',
          value: 'status',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
        {
          text: 'จำนวน',
          value: 'amount',
          align: 'center',
          sortable: false,
        },
        {
          text: 'หมายเหตุ',
          value: 'remark',
          align: 'center',
          justify: 'center',
          sortable: false,
        },
      ],
      items: [],
      totalItems: 0,
      options: {},
      query: {
        agentId: null,
        loan: null,
      },
      loanType: [
        { val: 'debit', label: 'ให้ยืม' },
        { val: 'credit', label: 'คืน' },
      ],
      amount: null,
      preload: false,
      showDateDialog: false,
      dateSelect: null,
      agentId: null,
    };
  },
  computed: {
    dateSelectDisplay() {
      return this.dateSelect;
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },

  mounted() {},

  methods: {
    fetchData() {
      this.loading = true;
      axios
        .get('/api/loan', {
          params: {
            page: this.options.page,
            sortBy: this.options.sortBy[0],
            sortDirection:
              this.options.sortDesc.length > 0
                ? this.options.sortDesc[0]
                  ? 'ASC'
                  : 'DESC'
                : null,
            dateRound: this.dateSelect,
            agentId: this.agentId,
            pageSize: this.options.itemsPerPage,
          },
        })
        .then((response) => {
          this.items = response.data.data;
          this.totalItems = response.data.total;
        })
        .catch((error) => {
          if (error.response.status == 409) {
            Vue.$toast.open({
              message: 'ไม่มีสิทธิ์ใช้งาน',
              type: 'error',
              duration: 5000,
              position: 'top-right',
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addLoan() {
      this.preload = true;

      const conf = confirm('ต้องการบันทึกนี้ใช่ไหม');
      if (conf) {
        axios
          .post('/api/loan', {
            params: {
              agentId: this.query.agentId,
              loan: this.query.loan,
              amount: this.amount,
            },
          })
          .then((response) => {
            if (response.status == 200) {
              Vue.$toast.open({
                message: 'บันทึกสำเร็จ',
                type: 'success',
                duration: 5000,
                position: 'top-right',
              });
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
              Vue.$toast.open({
                message: 'ไม่สามารถบันทึกได้กรุณาลองใหม่',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else if (error.response.status == 409) {
              Vue.$toast.open({
                message: 'ไม่มีสิทธิ์ใช้งาน',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else if (error.response.status == 402) {
              Vue.$toast.open({
                message: 'เครดิตเอเจนไม่เพียงพอ',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            } else {
              Vue.$toast.open({
                message: 'ไม่สามารถบันทึกได้กรุณาลองใหม่',
                type: 'error',
                duration: 5000,
                position: 'top-right',
              });
            }
          })
          .finally(() => {
            this.fetchData();
            this.preload = false;
          });
      }
    },

    validateNumber(evt) {
      evt = evt || window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31
        && (charCode < 48 || charCode > 57)
        && charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    closeDialog() {
      this.digitsItem = false;
      this.digitsList = [];
    },
  },
};
</script>
